import { render, staticRenderFns } from "./SecurityItem.vue?vue&type=template&id=4afbec3c"
import script from "../../scripts/pages/SecurityItem.js?vue&type=script&lang=js&external"
export * from "../../scripts/pages/SecurityItem.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports